import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import readXlsxFile from 'read-excel-file';
import Modal from 'react-bootstrap/Modal';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class ImportExport extends React.Component {
    _isMounted = false;
    state = {
        alert: 0,
        alertMessage: '',
        WhatsappAlertChecked: false,
        flag: false,
        LastUpdatedTimeStamp: '',
        UpdatedBy: '',
        RequestedTimeStamp: '',
        StoreCPs: [],
        serveroptions: [],
        StoreTags: [],
        SelectedStoreCP: '',
        SelectedStoreCPName: '',
        storeFileUplaoded: false
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
    }

    DownloadTemplate = () => {
        window.open('/SampleStoreTags.xlsx');
    };

    handleFileUploaded = async (event) => {
        let mapRecords = [];
        if (event.target.files.length > 0) {
            if (this._isMounted) {
                this.setState({ flag: true });
            }
            this.file = event.target.files[0];
            
            await readXlsxFile(this.file, { getSheets: true })
                .then(async (sheets) => {
                    await sheets.forEach(async (value) => {
                        await readXlsxFile(this.file, {
                            sheet: value.name
                        }).then(async (sheetdata) => {
                            await sheetdata.forEach(async (sheetvalue) => {
                                if (sheetvalue[0] !== 'Store Tag') {
                                    mapRecords.push({
                                        StoreTag: sheetvalue[0],
                                        EmailId: sheetvalue[1],
                                        PhoneNumber: sheetvalue[2],
                                        StoreType: sheetvalue[3],
                                        Address: sheetvalue[4],
                                        Area: sheetvalue[5],
                                        City: sheetvalue[6],
                                        PinCode: sheetvalue[7],
                                        District: sheetvalue[8],
                                        State: sheetvalue[9],
                                        lock_status: sheetvalue[10],
                                        Password: sheetvalue[11]
                                    });
                                }
                            });
                        });
                    });
                    if (this._isMounted) {
                        this.setState({
                            storeFileUplaoded: true,
                            flag: false,
                            StoreTags: mapRecords
                        });
                    }
                })
                .catch(function (error) {});
        }
    };

    uplaodData = async (event) => {
        if (this.state.SelectedStoreCP) {
            let data = {
                WhatsappAlertChecked: this.state.WhatsappAlertChecked,
                StoreTagList: this.state.StoreTags,
                SelectedStoreCP: this.state.SelectedStoreCP,
                SelectedStoreCPName: this.state.SelectedStoreCPName,
                LastUpdatedTimeStamp: dateFormatUtil(),
                UpdatedBy: this.props.user.FullName
            };

            

            this.setState({ flag: true, alert: 4, alertMessage: '' });
            await RestServices.importStoreTagMapping(
                localStorage.getItem('FirebaseToken'),
                data
            )
                .then((response) => response.json())
                .then((responseData) => {
                   
                    if (responseData.status) {
                        if (responseData.warningStoreTags.length > 0) {
                            this.setState({
                                flag: false,
                                StoreTags: responseData.warningStoreTags,
                                alert: 3,
                                alertMessage: responseData.warningMessage
                            });
                        } else {
                            this.setState({
                                storeFileUplaoded: false,
                                flag: false,
                                alert: 2,
                                alertMessage: responseData.message
                            });
                        }
                    } else {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.message
                        });
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        } else {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: 'Please Select Channel Partner'
                });
            }
        }
    };

    cancelUplaodData = async (event) => {
        if (this._isMounted) {
            this.setState({ storeFileUplaoded: false, alert: 0 });
        }
    };

    forceuplaodData = async (event) => {
        if (this.state.SelectedStoreCP) {
            let data = {
                WhatsappAlertChecked: this.state.WhatsappAlertChecked,
                StoreTagList: this.state.StoreTags,
                SelectedStoreCP: this.state.SelectedStoreCP,
                SelectedStoreCPName: this.state.SelectedStoreCPName,
                LastUpdatedTimeStamp: dateFormatUtil(),
                UpdatedBy: this.props.user.FullName
            };

            this.setState({ flag: true, alert: 0, alertMessage: '' });
            await RestServices.forceimportStoreTagMapping(
                localStorage.getItem('FirebaseToken'),
                data
            )
                .then((response) => response.json())
                .then((responseData) => {
                    

                    if (responseData.status) {
                        this.setState({
                            storeFileUplaoded: false,
                            flag: false,
                            alert: 2,
                            alertMessage: responseData.message
                        });
                    } else {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.message
                        });
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        } else {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: 'Please Select Channel Partner'
                });
            }
        }
    };

    handleChangeWhatsappAlert = () => {
        if (this._isMounted) {
            this.setState({
                WhatsappAlertChecked: !this.state.WhatsappAlertChecked
            });
        }
    };

    async searchStoreCP(SearchKey) {
        let bodyData = {
            search_key: SearchKey,
            search_by: 'FullName',
            userRole: 'StoreCP',
            LastDocument: false,
            FirstDocument: false,
            StartAt: false,
            perPage: 10,
            moveTo: false
        };

        await RestServices.getAllProfilesPagination(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (StoreCP) => {
                let StoreCPList = [];

                StoreCP.list.forEach(async (item) => {
                    StoreCPList.push(
                        item.FullName + ' (' + item.ProfileUniqeID + ')'
                    );
                });
                if (this._isMounted) {
                    this.setState({ serveroptions: StoreCPList });
                }
            })
            .catch((err) => {});
    }

    render() {
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}
                
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Select Channel Partner</Form.Label>
                        <Autocomplete
                            name="SelectedStoreCP"
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    this.setState({
                                        SelectedStoreCPView: newValue
                                    });
                                    var StoreCP = newValue.substring(
                                        newValue.indexOf('(') + 1,
                                        newValue.lastIndexOf(')')
                                    );
                                    this.setState({ SelectedStoreCP: StoreCP });
                                    var newName = newValue.substring(
                                        0,
                                        newValue.lastIndexOf('(')
                                    );
                                    this.setState({
                                        SelectedStoreCPName: newName
                                    });
                                } else {
                                    this.setState({
                                        SelectedStoreCP: '',
                                        SelectedStoreCPName: ''
                                    });
                                }
                            }}
                            onInputChange={(event, newInputValue) => {
                                if (newInputValue.length > 1) {
                                    this.searchStoreCP(newInputValue);
                                }
                            }}
                            options={this.state.serveroptions.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                {!this.state.storeFileUplaoded && (<Row style={{ padding: '0px 15px' }}>
                    <Col>
                        <span>Upload a sheet:</span>
                        <Tooltip title="Upload File">
                            <IconButton aria-label="upload">
                                <label>
                                    <CloudUploadIcon />
                                    <input
                                        type="file"
                                        hidden
                                        id="custom-file-translate"
                                        lang="en"
                                        accept=".xlsx, .xls"
                                        onChange={this.handleFileUploaded}
                                    />
                                </label>
                            </IconButton>
                        </Tooltip>
                    </Col>
                </Row>)}
                {this.state.storeFileUplaoded  && this.file && (
                    <Row style={{ padding: '0px 15px' }}>
                    <Col>
                        <span>{this.file.name} Uploaded...</span>
                    </Col>
                </Row>)}

                {!this.state.storeFileUplaoded && (
                    <Row style={{ padding: '0px 15px' }}>
                        <Col>
                            <Button
                                style={{ marginTop: '1rem' }}
                                variant="info"
                                type="submit"
                                onClick={this.DownloadTemplate}
                            >
                                Download Template
                            </Button>
                        </Col>
                    </Row>
                )}

                <hr />
                {this.state.alert === 3 && (
                    <Alert variant="warning">{this.state.alertMessage}</Alert>
                )}

                {this.state.storeFileUplaoded && (
                    <div>
                        <Form.Row>
                            <Col style={{ marginBottom: '1rem' }}>
                                <input
                                    type="checkbox"
                                    id="whatsapp_alert"
                                    name="whatsapp_alert"
                                    value="whatsapp_alert"
                                    defaultChecked={
                                        this.state.WhatsappAlertChecked
                                    }
                                    onChange={this.handleChangeWhatsappAlert}
                                />{' '}
                                Inform the StoreCPs about the StoreTag changes
                                on Whatsapp
                            </Col>
                            {this.state.alert !== 3 && (
                                <Col>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        onClick={this.uplaodData}
                                    >
                                        Submit
                                    </Button>
                                
                                </Col>
                            )}
                            {this.state.alert === 4 && (
                                <Col>
                                 <Alert variant="warning">Please don't close the tab or change the window while we're uploading</Alert>
                            </Col>
                          )}

                            {this.state.alert === 3 && (
                                <Col>
                                    <Button
                                        variant="success"
                                        type="submit"
                                        onClick={this.forceuplaodData}
                                    >
                                        Changes Approved
                                    </Button>
                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="danger"
                                        type="submit"
                                        onClick={this.cancelUplaodData}
                                    >
                                        Cancel the upload
                                    </Button>
                                </Col>
                            )}
                        </Form.Row>
                    </div>
                )}
            </Container>
        );
    }
}

export default ImportExport;
